// images
const blogImg1 = "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80";
const blogImg2 = "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80";
const blogImg3 = "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=800&q=80";

const blog1 = "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80";
const blog2 = "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80";
const blog3 = "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800&q=80";

const blogSingleImg1 = "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=80";
const blogSingleImg2 = "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1200&q=80";
const blogSingleImg3 = "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=1200&q=80";


const blogs = [
    {
        id: '1',
        title: 'L\'avenir de l\'extrusion d\'aluminium : innovations et tendances.',
        title2: 'Les nouvelles technologies transforment la production d\'aluminium.',
        tag: 'Innovation',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack',
        screens: blogImg1,
        PageImg: blog1,
        description: 'Découvrez les dernières innovations dans le domaine de l\'extrusion d\'aluminium et leur impact sur l\'industrie.',
        author: 'Youssef Ben Ali',
        create_at: '27 Mai 2026',
        blogSingleImg: blogSingleImg1,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Extrusion Aluminium',
    },
    {
        id: '2',
        title: 'Recyclage de l\'aluminium : engagement durable pour l\'environnement',
        title2: 'Comment l\'aluminium recyclé transforme l\'industrie',
        tag: 'Durabilité',
        slug: 'Why-Industry-Are-A-Juicy-Target-For',
        screens: blogImg2,
        PageImg: blog2,
        description: 'L\'importance du recyclage dans la production d\'aluminium et ses bénéfices environnementaux et économiques.',
        author: 'Amira Trabelsi',
        create_at: '03 Sep 2026',
        blogSingleImg: blogSingleImg2,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Recyclage',
    },
    {
        id: '3',
        title: 'Certifications qualité dans l\'industrie de l\'aluminium',
        title2: 'Nous garantissons les meilleurs services de qualité',
        tag: 'Qualité',
        slug: 'Why-Industry-Are-A-Juicy',
        screens: blogImg3,
        PageImg: blog3,
        description: 'Les certifications ISO et les normes de qualité essentielles pour la production d\'aluminium industriel.',
        author: 'Salma Chouchene',
        create_at: '03 Sep 2026',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Contrôle Qualité',
    },
    {
        id: '4',
        title: 'Applications industrielles des profils d\'aluminium extrudés',
        title2: 'Nous garantissons les meilleurs services de qualité',
        tag: 'Applications',
        slug: 'Why-Industry-Are-A-Juicy2',
        screens: blogImg2,
        PageImg: blog1,
        description: 'Exploration des diverses applications des profils d\'aluminium dans différents secteurs industriels.',
        author: 'Khalil Ghariani',
        create_at: '03 Sep 2026',
        blogSingleImg: blogSingleImg2,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Applications Industrielles',
    },
];
export default blogs;
